// Module
var code = `<div class="loan-preview">
  <div id="accreted-charges-accordion" class="accordion amortization-accordion" ng-if="\$ctrl.hasDiscountCharges()">
    <table class="table">
      <thead>
      <tr>
        <th>No</th>
        <th>Date</th>
        <th>Days</th>
        <th>Income</th>
        <th>Discount charges</th>
        <th>Balance</th>
        <th ng-if="\$ctrl.showStatus">Status</th>
      </tr>
      </thead>
      <tbody class="tbody">
      <tr ng-repeat="row in \$ctrl.discountCharges.rows">
        <td>{{row.lineNumber}}</td>
        <td>{{row.accretionDate | prettyDate }}</td>
        <td>{{row.days}}</td>
        <td>{{row.income | nxCurrency:'dashOnZero'}}</td>
        <td>{{row.unearned | nxCurrency:'dashOnZero'}}</td>
        <td>{{row.balance | nxCurrency:'dashOnZero'}}</td>
        <td ng-if="\$ctrl.showStatus">{{row.status | prettyEnum}}</td>
      </tr>
      </tbody>
      <tbody class="tbody">
      <tr>
        <td>
          <strong>
            Total:
          </strong>
        </td>
        <td></td>
        <td>{{\$ctrl.discountCharges.totalDays}}</td>
        <td>{{\$ctrl.discountCharges.totalIncome | nxCurrency:'dashOnZero'}}</td>
        <td>{{\$ctrl.discountCharges.totalUnearned | nxCurrency:'dashOnZero'}}</td>
        <td></td>
        <td ng-if="\$ctrl.showStatus"></td>
      </tr>
      </tbody>
    </table>
  </div>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/common/discount-charges-ledger.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;